/**
 * CoffeeMates User Service — profile, connections, blocking, safety
 */
import httpClient from '../utils/httpClient';

export interface UserSummary {
  id: string;
  first_name: string;
  last_name: string;
  avatar_url: string | null;
  bio: string | null;
  industry: string | null;
}

const userService = {
  // Profile
  async updateProfile(data: Record<string, unknown>) {
    const { data: res } = await httpClient.put('/users/me', data);
    return res;
  },
  async acknowledgeSafety() {
    const { data } = await httpClient.post('/users/me/safety-acknowledge', { acknowledged: true });
    return data;
  },
  async deleteAccount() {
    const { data } = await httpClient.del('/users/me');
    return data;
  },

  // Connections
  async getConnections(): Promise<UserSummary[]> {
    const { data } = await httpClient.get<UserSummary[]>('/users/me/connections');
    return data;
  },
  async sendConnection(userId: string) {
    const { data } = await httpClient.post(`/users/me/connections/${userId}`);
    return data;
  },
  async removeConnection(userId: string) {
    const { data } = await httpClient.del(`/users/me/connections/${userId}`);
    return data;
  },

  // Blocking
  async getBlocked(): Promise<UserSummary[]> {
    const { data } = await httpClient.get<UserSummary[]>('/users/me/blocked');
    return data;
  },
  async blockUser(userId: string) {
    const { data } = await httpClient.post(`/users/me/block/${userId}`);
    return data;
  },
  async unblockUser(userId: string) {
    const { data } = await httpClient.del(`/users/me/block/${userId}`);
    return data;
  },

  // Wallet & Referral & Reputation
  async getWallet() {
    const { data } = await httpClient.get('/users/me/wallet');
    return data;
  },
  async getReferral() {
    const { data } = await httpClient.get('/users/me/referral');
    return data;
  },
  async getReputation() {
    const { data } = await httpClient.get('/users/me/reputation');
    return data;
  },

  // Safety reports
  async reportAbuse(report: { reported_user_id: string; event_id: string; category: string; description: string; anonymous?: boolean }) {
    const { data } = await httpClient.post('/reports/abuse', report);
    return data;
  },
  async reportHost(report: { venue_id: string; event_id: string; category: string; description: string }) {
    const { data } = await httpClient.post('/reports/host', report);
    return data;
  },
  async checkReportStatus(reportId: string) {
    const { data } = await httpClient.get(`/reports/abuse/${reportId}`);
    return data;
  },

  // Favorite venues
  async getFavoriteVenues() {
    const { data } = await httpClient.get('/venues/favorites/my');
    return data;
  },
  async favoriteVenue(venueId: string) {
    const { data } = await httpClient.post(`/venues/favorites/${venueId}`);
    return data;
  },
  async unfavoriteVenue(venueId: string) {
    const { data } = await httpClient.del(`/venues/favorites/${venueId}`);
    return data;
  },
};

export default userService;
